import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Form, FormInstance } from "antd";
import { generalStyleFormExtraItem } from "../modal-content";

export const ExtraVariant: React.FC<{ form: FormInstance }> = ({ form }) => {
  const isVariantLoading = Form.useWatch(FilterFormFieldsEnum.IS_EXP_LOADING, form);
  const expOtps = Form.useWatch(FilterFormFieldsEnum.VARIANTS_OPTIONS, form);

  return (
    <Form.Item
      {...generalStyleFormExtraItem}
      label="Variants"
      name={FilterFormFieldsEnum.EXTRA_VARIANTS}
      rules={[
        {
          required: true,
          message: "Please select variant",
        },
      ]}
    >
      <SelectWithSpinAndCustomMaxTag
        mode="multiple"
        allowClear
        placeholder="Select Variant"
        options={expOtps ?? []}
        loading={isVariantLoading}
      />
    </Form.Item>
  );
};
